import { ChartCard, type ChartCardState } from "../../ChartCard";
import { ToolCallsTable } from "../../ToolCallsTable";
import { useInstanceToolLogs } from "../../../../hooks/useInstanceToolLogs";
import type { AdminToolCall } from "../../../../hooks/useAdminToolCalls";
import type { InstanceRange } from "../../../../lib/instanceDetailRange";
import styles from "../instanceDetail.module.css";

type ToolLogsPanelProps = {
  readonly tenantId: string;
  readonly range: InstanceRange;
};

const cardState = (
  status: "loading" | "ready" | "error",
  calls: ReadonlyArray<AdminToolCall>,
): ChartCardState => {
  if (status === "loading") return "loading";
  if (status === "error") return "error";
  if (calls.length === 0) return "empty";
  return "ready";
};

export const ToolLogsPanel = ({ tenantId, range }: ToolLogsPanelProps): JSX.Element => {
  const {
    status,
    calls,
    error,
    isFetching,
    page,
    canPrev,
    canNext,
    pageStart,
    pageEnd,
    nextPage,
    prevPage,
  } = useInstanceToolLogs(tenantId, range);
  return (
    <ChartCard
      title="Recent tool logs"
      wide
      state={cardState(status, calls)}
      emptyText="No tool calls recorded for this instance in this window."
      errorText={error ?? undefined}
    >
      <div className={styles.hScroll}>
        <ToolCallsTable
          calls={calls}
          isFetching={isFetching}
          showCustomer={false}
          pager={{
            page,
            canPrev,
            canNext,
            pageStart,
            pageEnd,
            onPrev: prevPage,
            onNext: nextPage,
          }}
        />
      </div>
    </ChartCard>
  );
};
